import { useEffect, useRef } from 'react';

export const useRefScrollTo = () => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollIntoView();
    }
  }, []);

  return ref;
};
